module.exports = __webpack_public_path__ + "media/images/noticias/receta_digital-8bb05109d407b7318453be877fe524dd.png";